module.exports = __webpack_public_path__ + "static/media/mark-blue.9b24abec.svg";